import axios from 'axios';
const API_URL = process.env.VUE_APP_API_BASE + '/api/v1/';

import { PermissionChecker } from '@/utils/iam_utils.js';


import store from '../store';
const instance = axios.create({
    // baseURL: 'http://your-api-base-url.com', // Replace with your API base URL
});

const setAuthToken = (token) => {
    instance.interceptors.request.use((config) => {
        // Add your custom headers here
        config.headers['Authorization'] = token; // Replace with your actual JWT token
      
        return config;
    });
    // instance.interceptors.response.use(response => {
    //     return response;
    // })
}

if (localStorage.getItem('token')) {
    setAuthToken(localStorage.getItem('token'));
} else {
    store.dispatch('setValue', {key: 'loaded', value: true});
}

const saveUserChanges = async (user) => {
    try {
        const response = await instance.put(`${API_URL}save-user-changes`, user).catch((error) => {
            if (error.response.status == 400) {
                store.dispatch('addNotification', {type: 'error', text: error.response.data.message});
                return {error: error.response.data.message};
            }
        });
        if (response.status == 200){
            store.dispatch('addNotification', {type: 'success', text: 'User changes applied successfully'});
            store.dispatch('setValue', {key: 'userInformation', value: response.data.userInformation});
            store.dispatch('setValue', {key: 'licenceElem', value: response.data.licenceElem});
            store.dispatch('setValue', {key: 'userAddress', value: response.data.userAddress});
            store.dispatch('setValue', {key: 'userPhone', value: response.data.userPhone});
        }
        return response;
    } catch (error) {
        console.error('Error applying user changes:', error);
        store.dispatch('addNotification', {type: 'error', text: 'Error applying user changes'});
        return false
    }
}

const getReportList = async (account_id, page) => {
    try {
        const account_id_quiery = account_id ? `?account_id=${account_id}&page=${page}` : `?page=${page}`;
        const response = await instance.get(`${API_URL}fiu/get-reports-list${account_id_quiery}`);


        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error loading user reports list'});
        return false
    }
}
const getFilesList = async (account_id, page) => {
    try {
        const account_id_quiery = account_id ? `?account_id=${account_id}&page=${page}` : `?page=${page}`;
        const response = await instance.get(`${API_URL}get-files-list${account_id_quiery}`);
        store.dispatch('setValue', {key: 'fileList', value: response.data.response_files});
        store.dispatch('setValue', {key: 'totalFilesCount', value: response.data.totalFilesCount});

        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error loading user files list'});
        store
        return false
    }
}
const getUserBalance = async () => {
    try {
        const response = await instance.get(`${API_URL}get-balance`);
        store.dispatch('setValue', {key: 'credits_balance', value: response.data.credits_balance});
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error updating user balance'});
        return false
    }
}


const getSavedInfo = async () => {
    try {
        const response = await instance.get(`${API_URL}get-saved-info`);
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error updating user balance'});
        return false
    }
}


const requestWallet = async () => {
    try {
        const response = await instance.post(`${API_URL}allocate-wallet`);
        store.dispatch('setValue', {key: 'wallet', value: {loaded: true, address: response.data.address}});
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error requesting wallet'});
        return false
    }
}

const getAccount = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-account?id=${id}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error loading account data'});
        return false
    }
}
const getUser = async (id = '') => {
    let response = null;
    try {
        response = await instance.get(`${API_URL}get-user?id=${id}`).catch((error) => {
            if (error.response.status >= 400 && error.response.status < 500) {
                if (error.response.status == 500) {
                    store.dispatch('addNotification', {type: 'error', text: 'Error loading user data\n, Plese contact support'});
                }
                if (error.response.status == 403 || error.response.status == 404)  { 
                    localStorage.removeItem('token');
                    setAuthToken(null);
                }
                return error.response;
            }
        });
        if (response) {
            if (id) {
                return {
                    ...response.data,
                }
            } else {
                store.dispatch('setValue', {key: 'user', value: response.data.user});
                store.dispatch('setValue', {key: 'userAddress', value: response.data.userAddress});
                store.dispatch('setValue', {key: 'userPhone', value: response.data.userPhone});
                store.dispatch('setValue', {key: 'licenceElem', value: response.data.licenceElem});
                store.dispatch('setValue', {key: 'userInformation', value: response.data.userInformation});
                store.dispatch('setValue', {key: 'userPermissions', value: response.data.permissions});
                store.dispatch('setValue', {key: 'clientAccount', value: response.data.clientAccount});
                store.dispatch('setValue', {key: 'agreements', value: response.data.agreements});
                PermissionChecker.setPermissions(response.data.permissions);

                store.dispatch('setValue', { 
                    key: 'wallet', value: { 
                        loaded: true, 
                        address: response.data.wallet 
                    }
                });
            }
        }
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error loading user data'});
        // return false
    }
}


const register = async ({
    password,
    username, 
    email
}) => {
    try {
        let error_ = null;
        const response = await instance.post(`${API_URL}register`, {
            password,
            username,
            email
        }).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
        });
        if (error_) {
            return error_;
        }
        
        setAuthToken(response.data.token);
        localStorage.setItem('token', response.data.token);
        window.location.reload();
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during user registration.\nPlease try again or contact support'});
        return false
    }
};


const verifyTwoFaCode = async (token) => {
    try {
        const response = await instance.post(`${API_URL}user/verify-otp`, {
            token
        }).catch((error) => {
            if (error.response.status == 400) {
                return {};
            }
        })
        return response;
    }
    catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during token verification.\nPlease try again or contact support'});
        return false
    }
}

const verifyToken = async (token) => { 
    try {
        const response = await instance.post(`${API_URL}verify-token`, {
            token
        }).catch((error) => {
            if (error.response.status == 400) {
                return {};
            }
        })
        return response;
    }
    catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during token verification.\nPlease try again or contact support'});
        return false
    }
}

const sendVerificationEmail = async (mode) => {
    try {
        let error_ = null;
        const response = await instance.post(`${API_URL}send-verification-email`, {
            mode
        }).catch((error) => {
            if (error.response.status == 401) {
                return {error: error.response.data.message};
            }
        });
        if (response.status == 200) {
            store.dispatch('addNotification', {type: 'success', text: 'Verification email sent successfully'});
        }
        if (response.error) {
            store.dispatch('addNotification', {type: 'error', text: response.error});
        }
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error sending verification emaiil.\nPlease try again or contact support'});
        return false
    }

}


const login = async ({
    password,
    email,
    token
}) => {
    try {
        let error_ = null;
        const response = await instance.post(`${API_URL}login`, {
            password,
            email,
            token
        }).catch((error) => {
            if (error.response.data.message) {
                store.dispatch('addNotification', {type: 'error', text: error.response.data.message});
            } else {
                store.dispatch('addNotification', {type: 'error', text: 'There was an error during user login.\nPlease try again or contact the support'});
            }
        });

        if (error_) {
            return error_;
        }
        
        setAuthToken(response.data.token);
        return response;
    } catch (error) {
        // store.dispatch('addNotification', {type: 'error', text: 'There was an error during user login.\nPlease try again or contact the support'});
    }
};

const newDueDiligenceRequest = async (data) => {
    try {
        const response = await instance.post(`${API_URL}sanctino-screening`, data).catch((error) => {
            if (error.response.status != 200) {
                return error.response
            }
        });
        return response.data;
    } catch (error) {
        return false
    }
}

const getSansctionScreeningList = async (id) => {
    try {
        const response = await instance.get(`${API_URL}sanctino-screening/list?company_id=${id}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence request.\nPlease try again or contact the support'});
        return false
    }
}

const getSansctionScreeningInfo = async (id) => {
    try {
        const response = await instance.get(`${API_URL}sanctino-screening/${id}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence request.\nPlease try again or contact the support'});
        return false
    }
} 

const loadBackTestData = async (data) => {
    try {
        const response = await instance.post(`${API_URL}back-test-data`, {
            ...data
        }).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during back test data request.\nPlease try again or contact the support'});
        return false
    }
}

const uploadFileGeneral = async (file, url, metadata) => {
    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);
        console.log('metadata', metadata)
        if (metadata) {
            for (let key in metadata) {
                if (metadata[key] || url == 'upload-template-file') {
                    console.log('metadata key', key, metadata[key])
                    formData.append(key, metadata[key]);
                }
            }
        }
        for (let pair of formData.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }
        let response_info = null;
        fetch(`${API_URL}${url}`, {
            method: 'POST',
            body: formData,
            headers
        })
        .then(response => {
            response_info = response
            return response.json()
        })
        .then(data => {
            resolve({...data, status_code: response_info.status}); 
            if (response_info.status == 500) {
                throw Error('Failed to upload the file')
            }
            if (response_info.status == 401) {
                throw Error('Failed to upload the file')
            }
            if (response_info.status == 403) {
                throw Error('Failed to upload the file')
            }
        })
        .catch(error => {
            console.error('Error uploading file:', error);
            store.dispatch('addNotification', {type: 'error', text: 'There was an error uploading the file or file information.\nPlease try again or contact the support'});
            reject(error);
        });
    })
}


const createTask = async (data) => {
    try {
        const response = await instance.post(`${API_URL}task/create`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during task creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during task creation.\nPlease try again or contact the support'});
        return false
    }
}


const checkToken = async (token) => {
    try {
        const response = await instance.post(`${API_URL}check-access-token`, {
            token
        }).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        })
        if (response.status == 200) {
            return response.data;
        }

    } catch( error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during token verification.\nPlease try again or contact the support'});
        return false
    }
}

const createDueDiligence = async (id, label) => { 
    try {
        const response = await instance.post(`${API_URL}due-diligence/create`, {company_id: id, label}).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        })
      
        return response.data;
    } catch (error) {
        console.log(error, )
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence request.\nPlease try again or contact the support'});
        return false
    }
}

const dueDiligenceList = async (id) => {
    try {
        const response = await instance.get(`${API_URL}due-diligence/list${id ? '?company_id=' + id : ''}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence request.\nPlease try again or contact the support'});
        return false
    }
}

const saveDueDiligenceData = async (data) => {
    try {
        const response = await instance.post(`${API_URL}due-diligence/save`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during due diligence data save.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence data save.\nPlease try again or contact the support'});
        return false
    }
}

const loadDueDiligenceDocData = async ({token, id}) => {
    try {
        const response = await instance.post(`${API_URL}due-diligence-doc-info/`, {
            token,
            id
        }).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading due diligence document data.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading due diligence document data.\nPlease try again or contact the support'});
        return false
    }
}

const loadDueDiligenceData = async ({token, id}) => {
    try {
        const response = await instance.post(`${API_URL}due-diligence-info/`, {
            token,
            id
        }).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading due diligence data.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading due diligence data.\nPlease try again or contact the support'});
        return false
    }
}

const getTask = async (id) => {
    try {
        const response = await instance.get(`${API_URL}task/${id}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during task request.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during task request.\nPlease try again or contact the support'});
        return false
    }
}

const getTasks = async (id) => {
    try {
        const response = await instance.get(`${API_URL}task/list${id ? '?company_id=' + id : ''}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
        });
        return response.data;
    }
    catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during task request.\nPlease try again or contact the support'});
        return false
    }
}

const importPlayerData = async (file, data, dateFormat) => {
    const response = await uploadFileGeneral(file, 'import/upload-file', {mapping: JSON.stringify(data), dateFormat})
    return response;
}

const uploadTaskFile = async (file) => {
    const response = await uploadFileGeneral(file, 'task/upload-file')
    return response;
}

const uploadSupportFile = async (file) => {
    const response = await uploadFileGeneral(file, 'support/upload-file')
    return response;
}

const uploadFile = async (file, template) => {
    console.log('uploadFile', file, template)
    const response = await uploadFileGeneral(file, 'upload-file', {type: template })
    return response;
}

const uploadAgreement = async (file, account_id) => {
    const response = await uploadFileGeneral(file, 'agreement/upload', { account_id })
    return response;
}
const uploadAgreementUser = async (file) => {
    const response = await uploadFileGeneral(file, 'user/agreement/upload')
    return response;
}
const uploadKYCFile = async (file, metadata) => {
    const response = await uploadFileGeneral(file, 'upload-kyc-file', metadata)
    return response;
}

const uploadDueDiligenceDoc = async (file, metadata) => {
    const response = await uploadFileGeneral(file, 'due-diligence/upload-file', metadata)
    return response;
}

const availableTemplates = async () => {
    try {
        const response = await instance.get(`${API_URL}fiu/available-templates`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading templates.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading templates.\nPlease try again or contact the support'});
        return false
    }
}


const downloadTemplate = async (template, filename) => {
    try {
        const response = await fetch(`${API_URL}download-template/?template=${template}`, {
            method: 'GET',
            headers: new Headers({
                'Authorization': localStorage.getItem('token'),
            }),
        });

        if (!response.ok) {
            const data = await response.json();
            store.dispatch('addNotification', { type: 'error', text: data.message });
            return false;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url); // cleanup
        store.dispatch('addNotification', {type: 'success', text: `Template ${filename} downloaded in progress`});

        return true;

    } catch (error) {
        store.dispatch('addNotification', { type: 'error', text: 'There was an error downloading the template.\nPlease try again or contact the support' });
        return false;
    }
}

const downloadSupportFile = async (file) => {
    
    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });
    fetch(`${API_URL}get-support-file/?id=${file._id}`,{
        method: 'GET',
        headers: headers,
    })
    .then(response => response.blob())
    .then(async (blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', `${file.filename}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    })
    .catch(error => {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
        console.error('Error downloading file:', error);
    });
}

const downloadFile = async (fileId, selectedFile, original) => {

    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });
    const originalQuery = original ? '&original=1' : ''
    fetch(`${API_URL}get-file/?id=${fileId}${originalQuery}`,{
        method: 'GET',
        headers: headers,
    })
    .then(response => response.blob())
    .then(async (blob) => {
        console.log('blob', blob)
        if (blob.size < 100) {
            store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
            return;
        }
        
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        
        let file_name = selectedFile.name.split('.')
        file_name.pop()
        file_name = file_name.join('')
        link.setAttribute('download', `${file_name}.${(fileId == 'sample' || original) ? 'xlsx' : 'zip'}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    })
    .catch(error => {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
        console.error('Error downloading file:', error);
    });
}

const downloadInvoiceFile = async (fileId, selectedFile) => {

    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });
    fetch(`${API_URL}get-invoice-file/?id=${fileId}`,{
        method: 'GET',
        headers: headers,
    })
    .then(response => response.blob())
    .then(async (blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
      
        link.setAttribute('download', `${selectedFile.name}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    })
    .catch(error => {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
        console.error('Error downloading file:', error);
    });
}

const downloadAgreementFile = async (agreementId, name, version='', refresh = false) => {
    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });
    fetch(`${API_URL}get-agreement-file/?id=${agreementId}&version=${version}`,{
        method: 'GET',
        headers: headers,
    })
    .then(response => response.blob())
    .then(async (blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
      
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        if (refresh) {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    })
    .catch(error => {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
        console.error('Error downloading file:', error);
    });
}

const denyChanges = async (data) => {
    try {
        const response = await instance.post(`${API_URL}changes/deny`, data).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during request.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during request.\nPlease try again or contact the support'});
        // return false
        return false
    }

}


const getAffectedChanges = async (data) => {
    let error_ = false;
    try {
        
        const response = await instance.post(`${API_URL}changes/affected`, data).catch((error) => {
            error_ = true
            store.dispatch('addNotification', {type: 'error', text: error?.response?.data?.message || `There was an error during request.\nPlease try again or contact the support`});
        });
        return response.data;

    } catch (error) {
        if (!error_) {
            store.dispatch('addNotification', {type: 'error', text: 'There was an error during request.\nPlease try again or contact the support'});
        }
        return false
    }

}



const approveChanges = async (data) => {
    let error_ = false;
    try {
        const response = await instance.post(`${API_URL}changes/approve`, data).catch((error) => {
            error_ = true
            store.dispatch('addNotification', {type: 'error', text: error?.response?.data?.message || `There was an error during request.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        if (!error_) {
            store.dispatch('addNotification', {type: 'error', text: 'There was an error during request.\nPlease try again or contact the support'});
        }
        return false
    }
}

const createNewUbo = async (data) => {
    try {
        const response = await instance.post(`${API_URL}ubo/create`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during UBO creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during UBO creation.\nPlease try again or contact the support'});
        return false
    }
}
const updateTransactionProfile = async (id, data2) => {
    try {
        const response = await instance.put(`${API_URL}transaction-profile/update/${id}`, data2).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during transaction profile update.\nPlease try again or contact the support`});
        });
        console.log('1111111111111111 updateTransactionProfile', response)
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during transaction profile update.\nPlease try again or contact the support'});
        return false
    }
}

const updateAccountNumber = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}account-number/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during account number update.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during account number update.\nPlease try again or contact the support'});
        return false
    }
}

const createNewSanctionRequest = async (data) => { 
    try {
        const response = await instance.post(`${API_URL}sanction-screening`, data).catch((error) => {
            if (error.response.status != 200) {
                return error.response
            }
        });
        return response.data;
    } catch (error) {
        return false
    }
}


const updateUBO = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}ubo/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during UBO update.\nPlease try again or contact the support`});
        });
        return response.data;
    }
    catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during UBO update.\nPlease try again or contact the support'});
        return false
    }
}
const updatePerson = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}person/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during person update.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during person update.\nPlease try again or contact the support'});
        return false
    }
}
const updateEntity = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}entity/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during entity update.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during entity update.\nPlease try again or contact the support'});
        return false
    }
}


const updateMD = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}md/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during MD update.\nPlease try again or contact the support`});
        })
        return response.data;
    } 
    catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during MD update.\nPlease try again or contact the support'});
        return false
    }
}


const updateFile = async (id, file, metadata) => {
    const response = await uploadFileGeneral(file, `file/update/${id}`, metadata)
    return response;
}

const createMD = async (data) => {
    try {
        const response = await instance.post(`${API_URL}md/create`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during MD creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during MD creation.\nPlease try again or contact the support'});
        return false
    }
};

const createShareholder = async (data) => {
    try {
        const response = await instance.post(`${API_URL}shareholder/create`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during shareholder creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during shareholder creation.\nPlease try again or contact the support'});
        return false
    }
}

const createPerson = async (data) => {
    try {
        const response = await instance.post(`${API_URL}person/create`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during person creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during person creation.\nPlease try again or contact the support'});
        return false
    }
}

const loadDashboardData = async ({snapshot_id, company_id}) => {
    try {

        let path = `dashboard-data?company_id=${company_id}${snapshot_id ? '&snapshotId=' + snapshot_id : ''}`;

        const response = await instance.get(`${API_URL}${path}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading dashboard data.\nPlease try again or contact the support`});
        });
        store.dispatch('setValue', { key: 'companyData', value: response.data.companyData});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading dashboard data.\nPlease try again or contact the support'});
        return false
    }
}

const updateShareholder = async (id, data) => {
    try {
        const response = await instance.put(`${API_URL}shareholder/update/${id}`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during shareholder update.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during shareholder update.\nPlease try again or contact the support'});
        return false
    }
}

const getKycFilesV2 = async ({snapshot_id, company_id}) => {
    try {
        store.dispatch('setValue', { key: 'kyc_files', value: null});
        store.dispatch('setValue', { key: 'kyc_ubos', value: null});
        store.dispatch('setValue', { key: 'kyc_entities', value: null});
        store.dispatch('setValue', { key: 'kyc_mds', value: null});
        store.dispatch('setValue', { key: 'kyc_persons', value: null});
        store.dispatch('setValue', { key: 'listingServices', value: null});
        store.dispatch('setValue', { key: 'kyc_accountNumbers', value: null});
        store.dispatch('setValue', { key: 'kyc_transactionalProfile', value: null});
        store.dispatch('setValue', { key: 'kyc_shareholders', value: null});

        if (!store.state.companyData || store.state?.companyData?._id != company_id) {
            store.dispatch('setValue', { key: 'companyData', value: null});
        }

        let path = `get-kyc-files-info_2?company_id=${company_id}${snapshot_id ? '&snapshotId=' + snapshot_id : ''}`;
        const response = await instance.get(`${API_URL}${path}`).catch((error) => {
            store.dispatch('addNotification', {type: 'error', text: 'There was an error during user login.\nPlease try again or contact the support'});
        });
        store.dispatch('setValue', { key: 'kyc_files', value: response.data.kycFiles});
        store.dispatch('setValue', { key: 'kyc_ubos', value: response.data.ubos});
        store.dispatch('setValue', { key: 'kyc_entities', value: response.data.entities});
        store.dispatch('setValue', { key: 'kyc_mds', value: response.data.mds});
        store.dispatch('setValue', { key: 'kyc_persons', value: response.data.persons});
        store.dispatch('setValue', { key: 'listingServices', value: response.data.listingServices});
        store.dispatch('setValue', { key: 'kyc_accountNumbers', value: response.data.account_number});
        store.dispatch('setValue', { key: 'kyc_transactionalProfile', value: response.data.transactional_profile});
        store.dispatch('setValue', { key: 'kyc_shareholders', value: response.data.shareholders});

        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during user login.\nPlease try again or contact the support'});
        return false
    }
}



async function getBanks(){
    try {
        const response = await instance.get(`${API_URL}banks/list`)
        store.dispatch('setValue', { key: 'banks', value: response.data.banks});
        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during bank info request.\nPlease try again or contact the support'});
        return false
    }
}
async function DownloadKYCFile(id, name, viewingToken) {
    let token;
    if (!viewingToken){
        await generateViewToken(viewingToken);
        token = store.state.viewingToken;
    } else {
        token = viewingToken;
    }
    
    const headers = new Headers({
        'Authorization': localStorage.getItem('token'), // Example header for authentication
    });

    fetch(`${API_URL}get-kyc-file/?id=${id}&viewingToken=${token}`,{
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        console.log('response', response)
        if (response.status != 200) {
            store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
            return;
        }
        return response.blob()
    })
    .then(async (blob) => {
        if (!blob) {
            return;
        }
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    })
    .catch(error => {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error downloading the file.\nPlease try again or contact the support'});
        console.error('Error downloading file:', error);
    });
}

async function getNotificationsByCompany({view, search = '', ordering, page}) {
    
    try {
        const orderKey = Object.keys(ordering)[0];
        const orderValue = ordering[orderKey];

        const response = await instance.get(`${API_URL}notification-by-client?view=${view}&search=${search}&orderingKey=${orderKey}&orderingValue=${orderValue}&page=${page}`).catch((error) => {
            if (error.response.status == 401) {
                error_ = {error: error.response.data.message};
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during Request.\nPlease try again or contact the support`});
        });;
        // store.dispatch('setValue', {key: 'notificationsCount', value: response.data.count});
        
        return response.data;
    } catch (error) {
        console.error('error', error)
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading notifications count.\nPlease try again or contact the support'});
        return false
    }
}

async function deleteObject(object_id, type, objectName) {
    console.log('delete ubo', object_id)
    let error_ = null;

    const response = await instance.post(`${API_URL}delete-object`, {
        id: object_id,
        type,
        accessToken: store.state.accessToken
    }).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error during ${objectName} deletion.\nPlease try again or contact the support`});
    });
    console.log('response', response)
    if (response.data.status != 'success') {
        store.dispatch('addNotification', {type: 'error', text: `There was an error during ${objectName} deletion.\nPlease try again or contact the support`});
        return false;
    } else {
        store.dispatch('addNotification', {type: 'success', text: `Deleted request has been submitted successfully`});
        
        if (store.state.user) {
            const response = await getNotificationList({ page: 1, view: 'forConfirmation', id: store.state.companyData._id });
            store.state.confirmationNeeded = response.notifications;
            store.state.notificationsCount = response.count;
        }

    }
    if (error_) {
        return false;
    }
    return true
}



async function uploadComment(content) {
    console.log('uploadComment')
    let error_ = null;

    const response = await instance.post(`${API_URL}comment-upload`, {comment_structure: content}).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error during company settings update.\nPlease try again or contact the support`});
    });
    console.log('response', response)
    if (response && response.data.status != 'success') {
        store.dispatch('addNotification', {type: 'error', text: `There was an error during company settings update.\nPlease try again or contact the support`});
        return false;
    }
    if (error_) {
        return false;
    }
    return true
}



async function updateKycReviewInfo(id, settings) {
    let error_ = null;

    const response = await instance.post(`${API_URL}update/kyc-review/${id}`, settings).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error during company settings update.\nPlease try again or contact the support`});
    });
    if (response.data.status != 'success') {
        store.dispatch('addNotification', {type: 'error', text: `There was an error during company settings update.\nPlease try again or contact the support`});
        return false;
    }
    return response.data
}

async function forgotPassword(email) {
    let error_ = null;

    const response = await instance.post(`${API_URL}user/forgot-password-request`, {
        email: email
    }).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error sending email with reset link.\nPlease try again or contact the support`});
    })
    if (response && response.data && response.data.timeout) {
        store.dispatch('addNotification', {type: 'error', text: `You can send new email in ${Math.floor(response.data.timeout)} seconds`});
        return null
    }
    return response.data;
}

async function resetPassword(data) {
    let error_ = null;
    const response = await instance.post(`${API_URL}user/forgot-password-response`, data).catch((error) => {
        return error.response
    })
    return response;
}


async function createSnapshot(data) {
    let error_ = null;
    const response = await instance.post(`${API_URL}snapshot-save`, data).catch((error) => {
        return error.response
    })
    return response.data;
}


async function getUserAccounts() {
    console.log('getUserAccounts')
    let error_ = null;
    const response = await instance.get(`${API_URL}user/accounts`).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading users of the company.\nPlease try again or contact the support`});
    })
    store.dispatch('setValue', {key: 'accounts', value: response.data});

    return response.data;
}

async function deleteUser(user_id) {
    let error_ = null;
    const response = await instance.post(`${API_URL}user/account/delete`, {user_id}).catch((error) => {
        return error.response
    })
    return response;
}

async function createNewUser(user){ 
    try {
        const response = await instance.post(`${API_URL}user/account/create`, user).catch((error) => {
            if (error.response.data.message) {
                store.dispatch('addNotification', {type: 'error', text: error.response.data.message});
                return false;
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error creating user for the company.\nPlease try again or contact the support`});
        })
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error creating user for the company.\nPlease try again or contact the support'});
        return false
    }
}

async function getNotificationList({
    page=1,
    view='forConfirmation',
    id=null
}) {
    const limit = 200;

    const offset = (page - 1) * limit;
    const response = await instance.get(`${API_URL}notifications?offset=${offset}&limit=${limit}&view=${view}&company_id=${id}`).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading notifications.\nPlease try again or contact the support`});
    })
    return response.data;
}

async function markNotificationAsRead(notification_id) {
    const response = await instance.post(`${API_URL}notifications/read`, {notification_id}).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error updating notifications.\nPlease try again or contact the support`});
    })
    return response.data;
}


async function getNotificationCount({
    view = 'forConfirmation',
    id
}) {
    const response = await instance.get(`${API_URL}notifications/count?view=${view}&company_id=${id}`).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading notifications.\nPlease try again or contact the support`});
        return null
    })
    store.dispatch('setValue', {key: 'notificationsCount', value: response.data.count});
    console.log('response COUNT', response)

    return response.data;
}

async function updateDueDiligenceState(data) {
    let error_ = null;
    const response = await instance.post(`${API_URL}due-diligence/state`, data).catch((error) => {
        if (error.response.status >= 400 && error.response.status < 500) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: error_?.error|| `There was an error updating due diligence state.\nPlease try again or contact the support`});
        return null
    })
    console.log('response', response)
    return response?.data;
}


async function changeDocumentState(data) {
    
    let error_ = null;
    const response = await instance.post(`${API_URL}document/state`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error updating document state.\nPlease try again or contact the support`});
    })
    return response.data;

}

async function generateViewToken(viewingToken) {
    const response = await instance.post(`${API_URL}generate-view/token`, {
        token: viewingToken
    }).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error generating view token.\nPlease try again or contact the support`});
        return null
    })
    store.dispatch('setValue', { key: 'viewingToken', value: response.data.token});
    
    setTimeout(() => {
        store.dispatch('setValue', { key: 'viewingToken', value: null});
    }, 60000)
}

async function createTicket(data) {
    const response = await instance.post(`${API_URL}support/create`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error creating ticket.\nPlease try again or contact the support`});
    })
    return response.data;
}

async function getTickets(data) {
    const response = await instance.get(`${API_URL}support/get/tickets`).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading tickets.\nPlease try again or contact the support`});
    })
    return response.data;
}
async function getTicket(tikcetId) {
    const response = await instance.get(`${API_URL}support/get/ticket/${tikcetId}`).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading ticket.\nPlease try again or contact the support`});
    })
    return response.data;
}

async function sendTaskMessage(data) {
    const response = await instance.post(`${API_URL}task/message/create`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error creating ticket.\nPlease try again or contact the support`});
    })
    return response.data;
}


async function sendTicketMessage(data) {
    const response = await instance.post(`${API_URL}support/message/create`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error creating ticket.\nPlease try again or contact the support`});
    })
    return response.data;
}

async function updateTaskStatus(data) {
    const response = await instance.post(`${API_URL}task/update`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error updating task.\nPlease try again or contact the support`});
    })
    return response.data;
}

async function updateTicketStatus(data) {
    const response = await instance.post(`${API_URL}support/ticket/update`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error updating ticket.\nPlease try again or contact the support`});
    })
    return response.data;
}
async function sendContactInfoText(data) {
    const response = await instance.post(`${API_URL}contact-info-text`, data).catch((error) => {
        if (error.response.status == 401) {
            error_ = {error: error.response.data.message};
        }

        store.dispatch('addNotification', {type: 'error', text: `There was an error sending contact info text.\nPlease try again later`});
        return null
    })
    return response.data;
}
async function getSnapshotList(id){
    const response = await instance.get(`${API_URL}snapshots/list?id=${id}`).catch((error) => {
        store.dispatch('addNotification', {type: 'error', text: `There was an error loading snapshots.\nPlease try again or contact the support`});
    })
    return response.data;
}

const getPageContent = async (type, raw) => {
    try {
        const params = new URLSearchParams();
        if (type) params.append('type', type);
        if (raw) params.append('raw', '1');
        const query = params.toString() ? `?${params.toString()}` : '';

        const response = await instance.get(`${API_URL}get-page-content${query}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading terms', type: 'error'});
        return false;
    }
}

const getUserInfo = async (user_id) => {
    try {
        const response = await instance.get(`${API_URL}user/account?id=${user_id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading user info', type: 'error'})
        return false
    }
}
const loadPermissions = async (user_id) => {
    try {
        const response = await instance.get(`${API_URL}user/account/permissions?id=${user_id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading user info', type: 'error'})
        return false
    }
}
const getRoles = async () => {
    try {
        const response = await instance.get(`${API_URL}get-roles`);
        store.dispatch('setValue', {key: 'roles', value: response.data.roles});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading roles', type: 'error'})
        return false
    }
}

const updateUserPermissions = async (data) => {
    try {
        const response = await instance.post(`${API_URL}update-permissions`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error updating permissions', type: 'error'})
        return false
    }
}

const updateUser = async (data) => {
    try {
        const response = await instance.post(`${API_URL}user/account/update`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error updating user', type: 'error'})
        return false
    }
}
const changePassword = async (data) => {
    let error = null;
    try {
        const response = await instance.post(`${API_URL}user/account/change-password`, data).catch((error) => {
            return error.response
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error changing password', type: 'error'})
        return false
    }
}

const saveSanctionAsPDF = async (data) => {
    let error = null;
    try {
        const response = await instance.post(`${API_URL}save-sanction-as-pdf`, data).catch((error) => {
            return error.response
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error saving sanction as pdf', type: 'error'})
        return false
    }
}

const getFileById = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-kycfile/${id}`);
        return response.data;
    } catch (error) {
        
        store.dispatch('addNotification', {text: 'Error loading file', type: 'error'})
        return null;
    }
}

const loadTransactionProfileData = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-transactional-profile/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading transaction profile', type: 'error'})
        return null;
    }
}

const getAccountNumberById = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-account-number/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading account number', type: 'error'})
        return null;
    }
}
const getPersonById = async (data) => {
    try {
        const response = await instance.get(`${API_URL}get-person/${data.id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading person', type: 'error'})
        return null;
    }
}
const getEntityById = async (data) => {
    try {
        const response = await instance.get(`${API_URL}get-entity/${data.id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading entity', type: 'error'})
        return null;
    }
}

const getUBOById = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-ubo/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading UBO', type: 'error'})
        return null;
    }
}

const getShareHolderById = async (id) => {
    try {
        const response = await instance.get(`${API_URL}get-shareholder/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading shareholder', type: 'error'})
        return null;
    }
}

const getMDById = async ({ id }) => {
    try {
        const response = await instance.get(`${API_URL}get-md/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading MD', type: 'error'})
        return null;
    }
} 



const getDueDiligenceElementById = async ({ id }) => {
    try {
        const response = await instance.get(`${API_URL}due-diligence/element/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading due diligence element', type: 'error'})
        return null;
    }
}

const getDueDiligenceRecordById = async ({ id }) => {
    try {
        const response = await instance.get(`${API_URL}due-diligence/record/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading due diligence record', type: 'error'})
        return null;
    }
}

const getSubsidiaryById = async ({ id }) => {
    try {
        const response = await instance.get(`${API_URL}get-subsidiary/${id}`).catch((error) => {
            if (error.response.status == 404) {
                store.dispatch('addNotification', {type: 'error', text: `Associated object was not found`});
                return error.response
            }
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading subsidiary', type: 'error'})
        return null;
    }
}

const createCompany = async (data) => {
    try {
        const response = await instance.post(`${API_URL}create-company`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error creating company', type: 'error'})
        return null;
    }
}

const getCompamniesList = async (search = '', ordering, page, filters) => {
    const orderKey = Object.keys(ordering)[0];
    const orderValue = ordering[orderKey];
    try {
        const response = await instance.post(`${API_URL}companies/list?search=${search}&orderingKey=${orderKey}&orderingValue=${orderValue}&page=${page}`, {
            filters
        }).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading companies list.\nPlease try again or contact the support`});
        });
        return response.data;

    } catch (error) {

        store.dispatch('addNotification', {text: 'Error loading companies', type: 'error'})
        return null;
        
    }
} 



const createAccountNumber = async (company_id) => {
    try {
        const response = await instance.post(`${API_URL}account-number/create`, {company_id});
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error creating account number', type: 'error'})
        return null;
    }
}
const loadNotification = async (id) => {
    try {
        const response = await instance.get(`${API_URL}notification/${id}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading notification', type: 'error'})
        return null;
    }
}

const updateListingServices = async (data) => {
    try {
        const response = await instance.put(`${API_URL}listing-services/update`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error updating listing services', type: 'error'})
        return null;
    }
}

const completeReport = async (data) => {
    try {
        const response = await instance.post(`${API_URL}complete-report`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error completing report', type: 'error'})
        return null;
    }
}

const createFileSection = async (data) => {
    try {
        const response = await instance.post(`${API_URL}file-section/create`, data);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error creating file section', type: 'error'})
        return null;
    }
}

const postError = async (data) => {
    try {
        const response = await instance.post(`${API_URL}error`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during error creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during error creation.\nPlease try again or contact the support'});
        return false
    }
}

const submitDueDiligenceReport = async (data) => {
    try {
        const response = await instance.post(`${API_URL}due-diligence/submit-report`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during due diligence report submission.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence report submission.\nPlease try again or contact the support'});
        return false
    }
}

const addDueDiligenceElement = async(data) => {
    try {
        const response = await instance.post(`${API_URL}due-diligence/add-element`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error during due diligence element creation.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error during due diligence element creation.\nPlease try again or contact the support'});
        return false
    }
    
}

const getOpenOrders = async (data) => {
    try {
        const response = await instance.post(`${API_URL}open-orders`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading open orders.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading open orders.\nPlease try again or contact the support'});
        return false
    }
}

const getFillRate = async () => {
    try {
        const response = await instance.get(`${API_URL}volume-fill-rate`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading fill rate.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading fill rate.\nPlease try again or contact the support'});
        return false
    }
}
const loadTradesData = async (data) => {
    try {
        const response = await instance.post(`${API_URL}trades-data`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading trades data.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading trades data.\nPlease try again or contact the support'});
        return false
    }
}

const loadOrderBookData = async (data) => {
    try {
        const response = await instance.post(`${API_URL}order-book-data`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading order book data.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading order book data.\nPlease try again or contact the support'});
        return false
    }
}

const exportReport = async (data) => {
    try {
        const response = await instance.post(`${API_URL}export-report`, data).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error exporting report.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error exporting report.\nPlease try again or contact the support'});
        return false
    }
}

const FIUDashboardData = async (statDate, endDate, account_id, full) => {
    try {
        let extra_params = account_id ? `&account_id=${account_id}` : '';
        if (full) {
            extra_params = '&full=1'
        }
        const response = await instance.get(`${API_URL}fiu/dashboard?start_date=${statDate}&end_date=${endDate}${extra_params}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading dashboard data.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading dashboard data.\nPlease try again or contact the support'});
        return false
    }
}

const getDistributionDataByClient = async (statDate, endDate) => {
    try {
        const response = await instance.get(`${API_URL}fiu/report-distribution-by-client?start_date=${statDate}&end_date=${endDate}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading distribution data', type: 'error'})
        return null;
    }
}

const getDistributionData = async (statDate, endDate, account_id, full) => {
    try {
        let extra_params = account_id ? `&account_id=${account_id}` : '';
        if (full) {
            extra_params = '&full=1'
        }
        const response = await instance.get(`${API_URL}fiu/report-distribution?start_date=${statDate}&end_date=${endDate}${extra_params}`);
        return response.data;
    } catch (error) {
        store.dispatch('addNotification', {text: 'Error loading distribution data', type: 'error'})
        return null;
    }
}



const invoices = async (account_id, total_view) => {
    try {
        const account_id_param = account_id ? `?account_id=${account_id}` : '';
        const total_view_param = total_view ? `${account_id ? '&' : '?'}total_view=1` : '';

        const response = await instance.get(`${API_URL}user/invoice/list${account_id_param}${total_view_param}`).catch((error) => {
            if (error.response.status == 401) {
                return error.response.data
            }
            store.dispatch('addNotification', {type: 'error', text: `There was an error loading invoices.\nPlease try again or contact the support`});
        });
        return response.data;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading invoices.\nPlease try again or contact the support.'});
        return false
    }
}

const getPlayerList = async (account_id, page) => {
    try {
        const account_id_quiery = account_id ? `?account_id=${account_id}&page=${page}` : `?page=${page}`;
        const response = await instance.get(`${API_URL}fiu/players/list${account_id_quiery}`);
        return response.data;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading players list.\nPlease try again or contact the support.'});
        return false
    }
}

const getImportList = async (account_id, page) => {
    try {
        const account_id_quiery = account_id ? `?account_id=${account_id}&page=${page}` : `?page=${page}`;
        const response = await instance.get(`${API_URL}fiu/imports/list${account_id_quiery}`);
        return response.data;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading players list.\nPlease try again or contact the support.'});
        return false
    }
}
const checkImportStatus = async (import_id) => {
    try {
        const response = await instance.get(`${API_URL}fiu/imports/status?import_id=${import_id}`);
        return response.data;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading import status.\nPlease try again or contact the support.'});
        return false
    }
}

const getPlayerInfo = async (player_id) => {
    try {
        const response = await instance.get(`${API_URL}fiu/player/info?player_id=${player_id}`);
        return response.data;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', {type: 'error', text: 'There was an error loading player info.\nPlease try again or contact the support.'});
        return false
    }
}

// --- Web grid ---

const getTemplateColumns = async (type) => {
    try {
        const response = await instance.get(`${API_URL}fiu/templates/columns`, { params: { type } });
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || 'There was an error loading the template.\nPlease try again or contact the support.';
        store.dispatch('addNotification', { type: 'error', text: message });
        return false;
    }
}

// ids -> { [id]: { importDate, values: { 'Template Column': value } } }; ids not found are absent
const lookupPlayers = async (ids) => {
    try {
        const response = await instance.post(`${API_URL}fiu/players/lookup`, { ids });
        return response.data.players;
    } catch (error) {
        console.log(error);
        store.dispatch('addNotification', { type: 'error', text: 'There was an error loading player data.\nPlease try again or contact the support.' });
        return false;
    }
}

// Same response shape as uploadFile(): { id, found_errors, preview, warnings, message, status_code }
const submitGrid = async ({ type, filename, rows }) => {
    try {
        const response = await instance.post(`${API_URL}fiu/grid/submit`, { type, filename, rows });
        return { ...response.data, status_code: response.status };
    } catch (error) {
        if (error.response) {
            return { ...error.response.data, status_code: error.response.status };
        }
        store.dispatch('addNotification', { type: 'error', text: 'There was an error processing the data.\nPlease try again or contact the support' });
        return false;
    }
}

// --- My Files (drive) ---

const driveError = (error, fallback) => {
    const message = error.response?.data?.message || fallback;
    store.dispatch('addNotification', { type: 'error', text: message });
    return false;
}

// { parent, q, sort, direction } -> { items, path, search }
const driveList = async (params) => {
    try {
        const response = await instance.get(`${API_URL}fiu/drive/items`, { params });
        return response.data;
    } catch (error) {
        return driveError(error, 'There was an error loading your files.');
    }
}

const driveFolders = async () => {
    try {
        const response = await instance.get(`${API_URL}fiu/drive/folders`);
        return response.data.folders;
    } catch (error) {
        return driveError(error, 'There was an error loading your folders.');
    }
}

// { kind: 'folder'|'sheet', name, parent, templateType } -> item
const driveCreate = async (body) => {
    try {
        const response = await instance.post(`${API_URL}fiu/drive/items`, body);
        return response.data.item;
    } catch (error) {
        return driveError(error, 'The item could not be created.');
    }
}

// { name?, parent? } -> item
const driveUpdate = async (id, body) => {
    try {
        const response = await instance.patch(`${API_URL}fiu/drive/items/${id}`, body);
        return response.data.item;
    } catch (error) {
        return driveError(error, 'The item could not be updated.');
    }
}

const driveDelete = async (id) => {
    try {
        const response = await instance.delete(`${API_URL}fiu/drive/items/${id}`);
        return response.data;
    } catch (error) {
        return driveError(error, 'The item could not be deleted.');
    }
}

const driveDuplicate = async (id) => {
    try {
        const response = await instance.post(`${API_URL}fiu/drive/sheets/${id}/duplicate`);
        return response.data.item;
    } catch (error) {
        return driveError(error, 'The spreadsheet could not be copied.');
    }
}

// -> { sheet, path }
const driveGetSheet = async (id) => {
    try {
        const response = await instance.get(`${API_URL}fiu/drive/sheets/${id}`);
        return response.data;
    } catch (error) {
        return driveError(error, 'The spreadsheet could not be opened.');
    }
}

// Autosave. Never toasts: the editor shows the save state itself.
// -> { ok: true, version, updatedAt, rowCount } | { ok: false, conflict: true } | { ok: false, status }
// body: { version, chunkCount, chunks: { <index>: rows } (changed ones only), comments?, colWidths? }
const driveSaveSheet = async (id, body) => {
    try {
        const response = await instance.put(`${API_URL}fiu/drive/sheets/${id}`, body);
        return { ok: true, ...response.data };
    } catch (error) {
        return { ok: false, conflict: error.response?.status === 409, status: error.response?.status };
    }
}

// format: 'xlsx' | 'csv'
const driveExport = async (id, name, format = 'xlsx') => {
    try {
        const response = await instance.get(`${API_URL}fiu/drive/sheets/${id}/export`, { responseType: 'blob', params: { format } });
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name.replace(/\.(xlsx|csv)$/i, '')}.${format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return true;
    } catch (error) {
        return driveError(error, 'The spreadsheet could not be exported.');
    }
}

// Sheet exported as an .xlsx File object (same layout as a template upload) -> File | false
const driveSheetFile = async (id, name) => {
    try {
        const response = await instance.get(`${API_URL}fiu/drive/sheets/${id}/export`, { responseType: 'blob' });
        return new File([response.data], `${name.replace(/\.xlsx$/i, '')}.xlsx`, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    } catch (error) {
        return driveError(error, 'The spreadsheet could not be loaded.');
    }
}

const driveMultipart = async (url, file, fields = {}) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        for (const [key, value] of Object.entries(fields)) {
            if (value) formData.append(key, value);
        }
        const response = await instance.post(`${API_URL}${url}`, formData);
        return response.data;
    } catch (error) {
        return driveError(error, 'The file could not be imported.');
    }
}

// New spreadsheet from an .xlsx/.csv -> { item, warning }
const driveImport = (file, { parent, templateType } = {}) => driveMultipart('fiu/drive/import', file, { parent, templateType });

// Replace a spreadsheet's content with an .xlsx/.csv -> { sheet, warning }
const driveImportIntoSheet = (id, file) => driveMultipart(`fiu/drive/sheets/${id}/import`, file);

const userEvent = async(data) => {
    await instance.post(`${API_URL}event`, data)
}


const acceptAgreement = async () => {
    try {
        const response = await instance.post(`${API_URL}agreement/accept`).catch((error) => {
            if (error.response.status == 404) {
                store.dispatch('addNotification', {type: 'error', text: error.response.data.message});
                return
            }
        });

        if (!response) return false;

        const agreements = store.state.agreements;
        const index = agreements.findIndex(item => item.type == 'agreement')
        agreements[index] = response.data.agreement;
        console.log('agreements', agreements)
        store.dispatch('setValue', {key: 'agreements', value: agreements});
        store.dispatch('addNotification', {type: 'success', text: response.data.message});


        return response;
    } catch (error) {
        store.dispatch('addNotification', {type: 'error', text: 'Error Occured During Agreement Acceptance'});
        return false
    }
}

export default {
    getTemplateColumns,
    lookupPlayers,
    submitGrid,
    driveList,
    driveFolders,
    driveCreate,
    driveUpdate,
    driveDelete,
    driveDuplicate,
    driveGetSheet,
    driveSaveSheet,
    driveExport,
    driveSheetFile,
    driveImport,
    driveImportIntoSheet,
    updateUserPermissions,
    login,
    updateUser,
    register,
    getUser,
    deleteObject,
    uploadFile,
    userEvent,
    saveUserChanges,
    requestWallet,
    getUserBalance,
    createNewUser,
    getNotificationList,
    acceptAgreement,
    instance,
    API_URL,
    getUserAccounts,
    createSnapshot,
    getSavedInfo,
    updateKycReviewInfo,
    getFilesList,
    sendVerificationEmail,
    verifyToken,
    uploadComment,
    uploadKYCFile,
    uploadAgreement,
    uploadAgreementUser,
    markNotificationAsRead,
    getKycFilesV2,
    updateKycReviewInfo,
    getNotificationCount,
    forgotPassword,
    resetPassword,
    createTicket,
    generateViewToken,
    getTickets,
    getTicket,
    sendTicketMessage,
    updateTicketStatus,
    updateTaskStatus,
    uploadSupportFile,
    uploadTaskFile,
    sendContactInfoText,
    deleteUser,
    getSnapshotList,
    approveChanges,
    getAffectedChanges,
    denyChanges,
    getPageContent,
    getUserInfo,
    loadPermissions,
    getRoles,
    changePassword,
    verifyTwoFaCode,
    newDueDiligenceRequest,
    getSansctionScreeningList,
    getSansctionScreeningInfo,
    saveSanctionAsPDF,
    createNewUbo,
    createPerson,
    createMD,
    loadDashboardData,
    updateMD,
    updateUBO,
    updatePerson,
    updateEntity,
    updateFile,
    getFileById,
    getPersonById,
    getEntityById,
    getUBOById,
    getMDById,
    getShareHolderById,
    getSubsidiaryById,
    createCompany,
    getCompamniesList,
    updateAccountNumber,
    updateTransactionProfile,
    getBanks,
    createAccountNumber,
    createShareholder,
    updateShareholder,
    loadNotification,
    updateListingServices,
    getAccountNumberById,
    loadTransactionProfileData,
    completeReport,
    createFileSection,
    postError,
    createNewSanctionRequest,
    getNotificationsByCompany,
    createTask,
    getTasks,
    getTask,
    sendTaskMessage,
    dueDiligenceList,
    loadDueDiligenceData,
    createDueDiligence,
    checkToken,
    addDueDiligenceElement,
    saveDueDiligenceData,
    loadDueDiligenceDocData,
    uploadDueDiligenceDoc,
    submitDueDiligenceReport,
    changeDocumentState,
    updateDueDiligenceState,
    loadBackTestData,
    getDueDiligenceElementById,
    getDueDiligenceRecordById,
    loadOrderBookData,
    getFillRate,
    getOpenOrders,
    loadTradesData,
    exportReport,
    FIUDashboardData,
    getAccount,
    invoices,
    downloadAgreementFile,
    downloadInvoiceFile,
    downloadTemplate,
    downloadSupportFile,
    downloadFile,
    DownloadKYCFile,
    uploadFileGeneral,
    importPlayerData,
    availableTemplates,
    getPlayerList,
    getImportList,
    checkImportStatus,
    getDistributionData,
    getDistributionDataByClient,
    getReportList,
    getPlayerInfo
};
